import VParallax from './VParallax'

VParallax.install = function install (Vue) {
  Vue.component(VParallax.name, VParallax)
}

export default VParallax



// WEBPACK FOOTER //
// ./src/components/VParallax/index.js